module.exports = __webpack_public_path__ + "assets/img/empty.be2f2755.svg";